import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'link-tree',
    title: 'Link-Tree AcheiTere',
    loadComponent: () =>
      import('./pages/link-tree/link-tree.component').then(
        (m) => m.LinkTreeComponent
      ),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./pages/change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/navbar/navbar.component').then(
        (m) => m.NavbarComponent
      ),
    children: [
      {
        path: '',
        title: 'AcheiTere',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'anunciantes',
        title: 'Empresas e Profissionais | AcheiTere',
        loadComponent: () =>
          import('./pages/research/research.component').then(
            (m) => m.ResearchComponent
          ),
      },
      {
        path: 'anunciantes/:id/:city/:name/:categories',
        title: 'Empresas e Profissionais | AcheiTere',
        loadComponent: () =>
          import('./pages/detail-advertiser/detail-advertiser.component').then(
            (m) => m.DetailAdvertiserComponent
          ),
      },
      {
        path: 'promocoes',
        title: 'Promoções | AcheiTere',
        loadComponent: () =>
          import('./pages/research/research.component').then(
            (m) => m.ResearchComponent
          ),
      },
      {
        path: 'promocoes/:id/:city/:name/:categories',
        title: 'Promoções | AcheiTere',
        loadComponent: () =>
          import('./pages/detail-promotion/detail-promotion.component').then(
            (m) => m.DetailPromotionComponent
          ),
      },
      {
        path: 'planos',
        title: 'Planos | AcheiTere',
        loadComponent: () =>
          import('./pages/plans/plans.component').then((m) => m.PlansComponent),
      },
      {
        path: 'contratar-plano',
        title: 'Contratar Plano | AcheiTere',
        loadComponent: () =>
          import('./pages/hire-plan/hire-plan.component').then(
            (m) => m.HirePlanComponent
          ),
      },
      {
        path: 'categorias',
        title: 'Categorias | AcheiTere',
        loadComponent: () =>
          import('./pages/category/category.component').then(
            (m) => m.CategoryComponent
          ),
      },
      {
        path: '**',
        redirectTo: '/',
      },
    ],
  },
];
